import * as React from 'react';
import { memo } from 'react';

const SvgCheckCircle = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 12.07V13a10 10 0 1 1-5.93-9.14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M22 4 11 15l-3-3", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCheckCircle);

export { Memo as default };
